import { createContext, useContext, useEffect, useState } from "react";

const useMobileProviderContext = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isTabletDevice, setIsTabletDevice] = useState<boolean>(false);
  const [deviceWidth, setDeviceWidth] = useState<number>(window.innerWidth);
  const [deviceHeight, setDeviceHeight] = useState<number>(window.innerHeight);

  useEffect(() => {
    const handleDeviceSize = () => {
      setDeviceWidth(window.innerWidth);
      setDeviceHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleDeviceSize);

    setIsMobile(deviceWidth <= 768);
    setIsTabletDevice(deviceWidth > 768 && deviceWidth < 1200);

    return () => {
      window.removeEventListener("resize", handleDeviceSize);
    };
  }, [deviceHeight, deviceWidth]);

  return {
    isMobile,
    isTabletDevice,
  };
};

const MobileContext = createContext(
  {} as ReturnType<typeof useMobileProviderContext>
);

export const MobileContextProvider = ({ children }) => {
  return (
    <MobileContext.Provider value={useMobileProviderContext()}>
      {children}
    </MobileContext.Provider>
  );
};

export const useMobileContext = () => useContext(MobileContext);
